import React, { useLayoutEffect, useState, FC, PropsWithChildren } from 'react';
import { useBreakpoints } from 'common/hooks';

export enum MediaGalleryType {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

type Props = PropsWithChildren & { bot: boolean; type: MediaGalleryType };

export const AdaptiveMediaGalleryContainer: FC<Props> = ({ bot, type, children }) => {
  const { smMobile, mobile, tablet, desktop, largeDesktop } = useBreakpoints() || {
    smMobile: false,
    mobile: false,
    tablet: false,
    desktop: false,
    largeDesktop: false,
  };

  const isMobile = type === MediaGalleryType.Mobile && (smMobile || mobile || tablet);
  const isDesktop = type === MediaGalleryType.Desktop && (desktop || largeDesktop);

  const [isVisible, setIsVisible] = useState(false);

  useLayoutEffect(() => {
    setIsVisible(isMobile || isDesktop);
  }, [isMobile, isDesktop]);

  if (bot || isVisible) {
    return <>{children}</>;
  }
};
